import React, { ReactNode, useEffect } from "react";
import { FieldValues, FormProvider } from "react-hook-form";
import { useHookForm } from "mui-react-hook-form-plus";
import "./SwiperHeightFix.css";
import { Box } from "@mui/material";
import { FormStepProps } from "../../Forms/SwiperStepperActions";

export default function FormStep<T1 extends FieldValues, T2 extends object>({
  children,
  form,
  subForms,
  stepIndex,
}: {
  children: ReactNode;
  form: ReturnType<typeof useHookForm<T1, T2>>;
} & FormStepProps) {
  useEffect(() => {
    subForms.current[stepIndex] = form;
  }, [form.formState.isValid]);

  return (
    <FormProvider {...form}>
      <Box
        component={"form"}
        onSubmit={(e) => e.preventDefault()}
        sx={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        {children}
      </Box>
    </FormProvider>
  );
}
